import { apiCommonConfig } from './apiCommon.config';
import type { ApiConfig } from './apiConfigTypes';

export const apiDevConfig: ApiConfig = {
  ...apiCommonConfig,

  bifrostBaseUrl: 'https://qa-bifrost-api.foxplus.com',
  entitlementBaseUrl: 'https://dev-ent.fox.com',
  productBaseUrl: 'https://stage1-ue1-connect-fn.api.fox.com',
};
